// extracted by mini-css-extract-plugin
module.exports = {"container":"loginPage_container__2SEoY","loginContainerGrid":"loginPage_loginContainerGrid__13KMN","loginCard":"loginPage_loginCard__1rx-l","title":"loginPage_title__36XOL"};